I18n.translations || (I18n.translations = {});
I18n.translations["lv"] = I18n.extend((I18n.translations["lv"] || {}), {
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Pārbaude neizdevās: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Nevar dzēst ierakstu, jo ir atkarīgi %{record}",
          "has_one": "Nevar dzēst ierakstu, jo ir atkarīgs %{record}"
        }
      }
    }
  },
  "add_bank_account": {
    "perform_authorization": "Veikt bankas autentifikāciju"
  },
  "app": {
    "navigation": {
      "contact_title": "Finlo - Kontakti",
      "home_title": "Finlo - Sākumlapa",
      "loan_types_title": "Finlo - Aizdevumu veidi"
    },
    "pages": {
      "contact": "Kontakti",
      "home": "Sākums",
      "loan_types": "Aizdevumu veidi",
      "services": "Pakalpojumi"
    }
  },
  "common": {
    "apply": "PIETEIKTIES",
    "back": "Atpakaļ",
    "cancel": "Atcelt",
    "close": "Aizvērt",
    "confirm": "Apstiprināt",
    "contact_us": "Sazinieties ar mums",
    "delete": "Dzēst",
    "edit": "Rediģēt",
    "error": "Kļūda",
    "learn_more": "Uzzināt vairāk",
    "loading": "Notiek ielāde...",
    "next": "Tālāk",
    "required": "*",
    "save": "Saglabāt",
    "submit": "Nosūtīt",
    "success": "Veiksmīgi"
  },
  "contact": {
    "address_full": "Bukultu iela 11, Rīga, LV-1005",
    "address_hours": "Darba dienās: 9:00 - 18:00",
    "address_label": "Adrese",
    "contact_info_title": "Kontaktinformācija",
    "email_address": "info@finlo.lv",
    "email_label": "E-pasts",
    "email_response": "Atbildēsim 24h laikā",
    "error_message": "Atvainojiet, radās kļūda nosūtot ziņojumu. Lūdzu mēģiniet vēlreiz vai zvaniet mums.",
    "form": {
      "agree_marketing": "Es vēlos saņemt informāciju par jaunākajiem piedāvājumiem un aktualitātēm",
      "agree_terms_prefix": "Es piekrītu",
      "and": "un",
      "description": "Aizpildiet formu, un mēs sazināsimies ar jums pēc iespējas ātrāk.",
      "email": "E-pasta adrese",
      "first_name": "Vārds",
      "last_name": "Uzvārds",
      "message": "Ziņojums",
      "phone": "Telefona numurs",
      "privacy_policy_link": "privātuma politikai",
      "subject": "Temats",
      "submit_button": "Nosūtīt ziņojumu",
      "submitting": "Nosūta...",
      "terms_link": "lietošanas noteikumiem",
      "title": "Sūtīt ziņojumu"
    },
    "page_description": "Mums ir svarīgi dzirdēt jūsu viedokli un atbildēt uz jūsu jautājumiem. Sazinieties ar mums, un mēs atbildēsim 24 stundu laikā.",
    "page_title": "Sazinieties ar <span class='text-primary-500'>mums</span>",
    "phone_hours": "Darba dienās: 9:00 - 18:00",
    "phone_label": "Telefons",
    "phone_number": "67199606",
    "subjects": {
      "complaint": "Sūdzība",
      "existing": "Esošā aizdevuma jautājumi",
      "general": "Vispārīgi jautājumi",
      "loan": "Aizdevuma pieteikums",
      "other": "Cits"
    },
    "success_message": "Paldies par jūsu ziņojumu! Mēs sazināsimies ar jums!",
    "validation": {
      "email_invalid": "Nepareizs e-pasta formāts",
      "email_required": "E-pasta adrese ir obligāta",
      "first_name_required": "Vārds ir obligāts",
      "last_name_required": "Uzvārds ir obligāts",
      "message_required": "Ziņojums ir obligāts",
      "phone_required": "Telefona numurs ir obligāts",
      "subject_required": "Temats ir obligāts",
      "terms_required": "Jums jāpiekrīt privātuma politikai un lietošanas noteikumiem"
    }
  },
  "cookie_consent": {
    "accept": "Pieņemt",
    "decline": "Noraidīt",
    "message": "Mēs izmantojam sīkfailus, lai uzlabotu jūsu pieredzi mūsu vietnē. Turpinot izmantot vietni, jūs piekrītat mūsu",
    "privacy_policy_link": "privātuma politikai"
  },
  "currency": {
    "eur": "EUR",
    "symbol": "€"
  },
  "date": {
    "abbr_day_names": [
      "Sv.",
      "P.",
      "O.",
      "T.",
      "C.",
      "Pk.",
      "S."
    ],
    "abbr_month_names": [
      null,
      "Janv",
      "Febr",
      "Marts",
      "Apr",
      "Maijs",
      "Jūn",
      "Jūl",
      "Aug",
      "Sept",
      "Okt",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "svētdiena",
      "pirmdiena",
      "otrdiena",
      "trešdiena",
      "ceturtdiena",
      "piektdiena",
      "sestdiena"
    ],
    "formats": {
      "default": "%d.%m.%Y.",
      "long": "%Y. gada %e. %B",
      "short": "%e. %B"
    },
    "month_names": [
      null,
      "janvārī",
      "februārī",
      "martā",
      "aprīlī",
      "maijā",
      "jūnijā",
      "jūlijā",
      "augustā",
      "septembrī",
      "oktobrī",
      "novembrī",
      "decembrī"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "apmēram %{count} stunda",
        "other": "apmēram %{count} stundas",
        "zero": "apmēram %{count} stundas"
      },
      "about_x_months": {
        "one": "apmēram %{count} mēnesis",
        "other": "apmēram %{count} mēneši",
        "zero": "apmēram %{count} mēneši"
      },
      "about_x_years": {
        "one": "apmēram %{count} gads",
        "other": "apmēram %{count} gadi",
        "zero": "apmēram %{count} gadi"
      },
      "almost_x_years": {
        "one": "gandrīz %{count} gads",
        "other": "gandrīz %{count} gadi",
        "zero": "gandrīz %{count} gadi"
      },
      "half_a_minute": "pusminūte",
      "less_than_x_minutes": {
        "one": "mazāk par %{count} minūti",
        "other": "mazāk par %{count} minūtēm",
        "zero": "mazāk par %{count} minūtēm"
      },
      "less_than_x_seconds": {
        "one": "mazāk par %{count} sekundi",
        "other": "mazāk par %{count} sekundēm",
        "zero": "mazāk par %{count} sekundēm"
      },
      "over_x_years": {
        "one": "vairāk kā %{count} gads",
        "other": "vairāk kā %{count} gadi",
        "zero": "vairāk kā %{count} gadi"
      },
      "x_days": {
        "one": "%{count} diena",
        "other": "%{count} dienas",
        "zero": "%{count} dienas"
      },
      "x_minutes": {
        "one": "%{count} minūte",
        "other": "%{count} minūtes",
        "zero": "%{count} minūtes"
      },
      "x_months": {
        "one": "%{count} mēnesis",
        "other": "%{count} mēneši",
        "zero": "%{count} mēneši"
      },
      "x_seconds": {
        "one": "%{count} sekunde",
        "other": "%{count} sekundes",
        "zero": "%{count} sekundes"
      }
    },
    "prompts": {
      "day": "diena",
      "hour": "stunda",
      "minute": "minūte",
      "month": "mēnesis",
      "second": "sekunde",
      "year": "gads"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "ir jāpiekrīt",
      "blank": "ir jābūt aizpildītam",
      "confirmation": "nesakrīt ar apstiprinājumu",
      "empty": "ir jābūt aizpildītam",
      "equal_to": "ir jābūt vienādam ar %{count}",
      "even": "ir jābūt pāra skaitlim",
      "exclusion": "nav pieejams",
      "greater_than": "ir jābūt lielākam par %{count}",
      "greater_than_or_equal_to": "ir jābūt lielākam vai vienādam ar %{count}",
      "inclusion": "nav iekļauts sarakstā",
      "invalid": "nav derīgs",
      "less_than": "ir jābūt mazākam par %{count}",
      "less_than_or_equal_to": "ir jābūt mazākam vai vienādam ar %{count}",
      "model_invalid": "Validācija neizdevās: %{errors}",
      "not_a_number": "nav skaitlis",
      "not_an_integer": "ir jābūt veselam skaitlim",
      "odd": "ir jābūt nepāra skaitlim",
      "other_than": "jābūt citam nekā %{count}",
      "present": "jābūt tukšam",
      "required": "ir jābūt",
      "taken": "ir jau aizņemts",
      "too_long": {
        "one": "ir par garu (maksimums ir %{count} simbols)",
        "other": "ir par garu (maksimums ir %{count} simboli)",
        "zero": "ir par garu (maksimums ir %{count} simboli)"
      },
      "too_short": {
        "one": "ir par īsu (minimums ir %{count} simbols)",
        "other": "ir par īsu (minimums ir %{count} simboli)",
        "zero": "ir par īsu (minimums ir %{count} simboli)"
      },
      "wrong_length": {
        "one": "ir nepareizs garums (jābūt %{count} simbolam)",
        "other": "ir nepareizs garums (jābūt %{count} simboliem)",
        "zero": "ir nepareizs garums (jābūt %{count} simboliem)"
      }
    },
    "template": {
      "body": "Problēmas ir šajos ievades laukos:",
      "header": {
        "one": "Dēļ %{count} kļūdas šis %{model} netika saglabāts",
        "other": "Dēļ %{count} kļūdām šis %{model} netika saglabāts",
        "zero": "Dēļ %{count} kļūdām šis %{model} netika saglabāts"
      }
    }
  },
  "footer": {
    "about_us": "Par mums",
    "contacts": "Kontakti",
    "faq": "BUJ",
    "license": "Licence Nr.2016-026",
    "logo_alt": "Finlo",
    "other_title": "Cits",
    "privacy_policy": "Privātuma politika",
    "services": {
      "business_loan": "Biznesa attīstībai",
      "construction_loan": "Ēku būvniecībai",
      "farm_loan": "Zemniekiem",
      "loan_consolidation": "Kredītu apvienošana",
      "mortgage_loan": "Hipotekārais kredīts"
    },
    "services_title": "Pakalpojumi",
    "social_networks": "Sociālie tīkli",
    "terms_of_use": "Lietošanas noteikumi"
  },
  "header": {
    "address": "Bukultu iela 11, Rīga, LV-1005",
    "contact": "Kontakti",
    "contacts": "Kontakti",
    "faq": "BUJ",
    "home": "Sākums",
    "how_to_apply": "Kā pieteikties?",
    "logo_alt": "Finlo",
    "phone": "67199606",
    "services": "Pakalpojumi",
    "why_us": "Kāpēc mēs?",
    "working_hours": "Pirmdiena-Piektdiena: 08-17"
  },
  "helpers": {
    "select": {
      "prompt": "Lūdzu izvēlies"
    },
    "submit": {
      "create": "Izveidot %{model}",
      "submit": "Saglabāt %{model}",
      "update": "Atjaunināt %{model}"
    }
  },
  "home": {
    "about_us_title": "Par mums",
    "contact_page": {
      "company_address": "Bukultu iela 11, Rīga, LV-1005",
      "company_details": "Rekvizīti",
      "company_name": "SIA \"Digital Investment MGMT\"",
      "company_registration": "Reģistrācijas Nr: 40103162565",
      "faq_description": "Atbildes uz biežāk uzdotajiem jautājumiem par mūsu pakalpojumiem",
      "faq_section": "BUJ",
      "how_to_get_there": "Kā nokļūt?",
      "license": "Licence Nr.2016-026",
      "privacy_policy": "Privātuma politika",
      "social_networks": "Sociālie tīkli",
      "terms_of_use": "Lietošanas noteikumi",
      "working_hours": "Darba laiks",
      "working_hours_weekdays": "P-Pk. 8:00-17:00",
      "working_hours_weekend": "S., Sv.- slēgts"
    },
    "contact_phone": "67199606",
    "contact_us_title": "Sazinies ar mums",
    "faq": [
      {
        "title": "Vai iespējams kredītu atdot ātrāk?",
        "content": "Jā, kredītu pirms termiņa iespējams atdot ātrāk."
      },
      {
        "title": "Vai daļu kredīta iespējams saņemt uzreiz?",
        "content": "Steidzamu biznesa jautājumu risināšanai, varam izvērtēt daļu finansējuma izsniegt līguma parakstīšanas dienā."
      },
      {
        "title": "Ja aizdevumu ņemu kredītu apvienošanai, kurš dzēsīs kredītus?",
        "content": "FINLO aizdevumu pārskaitīs uz Jūsu norēķinu bankas kontu, līdz ar to Jūs būsiet atbildīgs par kredītu dzēšanu un maksājuma uzdevumu iesniegšanu dzēšanas apliecināšanai FINLO."
      },
      {
        "title": "Vai īpašumam tiks veikts nekustamā īpašuma novērtējums?",
        "content": "Jā, mēs pasūtam sertificēta vērtētāja īpašuma novērtējumu."
      }
    ],
    "faq_title": "Biežāk uzdotie jautājumi",
    "features": {
      "all_latvia": "Kreditējam visā Latvijā",
      "licensed_lender": "Licencēts aizdevējs",
      "real_estate_secured": "Nekustamā īpašuma nodrošināti kredīti",
      "since_2008": "Tirgū no 2008. gada"
    },
    "form_submitted_message": "Pieteikums nosūtīts!",
    "hero_title": "Mūsdienīga pieeja<br/>Aizdevumu izsniegšanai",
    "loan_types_page": {
      "application_submitted": "Jūsu pieteikums ir nosūtīts! Mēs ar jums sazināsimies tuvākajā laikā.",
      "apply_for_loan": "Pieteikt",
      "apply_now": "Pieteikties tagad",
      "competitive_rates": "Konkurencespējīgas likmes",
      "competitive_rates_description": "Piedāvājam vienas no zemākajām procentu likmēm tirgū no 9% + EURIBOR.",
      "fast_approval": "Ātra apstiprināšana",
      "fast_approval_description": "Pietekumu izvērtējam vienas darba dienas laikā un sniedzam atbildi ātri.",
      "fill_application": "Aizpildiet pieteikumu un saņemiet piedāvājumu",
      "flexible_terms": "Elastīgi nosacījumi",
      "hero_description": "Izvēlieties piemērotāko aizdevuma veidu savām vajadzībām. Mēs piedāvājam plašu pakalpojumu klāstu dažādiem mērķiem.",
      "hero_title": "Mūsu Pakalpojumi",
      "main_advantages": "Galvenās priekšrocības",
      "personal_approach": "Personīga pieeja",
      "personal_approach_description": "Katram klientam piedāvājam individuālu risinājumu, kas atbilst jūsu vajadzībām.",
      "required_documents": "Nepieciešamie dokumenti",
      "trusted_partner": "Mēs esam jūsu uzticamais partneris aizdevumu jomā ar vairāk nekā 10 gadu pieredzi",
      "why_choose_finlo": "Kāpēc izvēlēties Finlo?"
    },
    "qualities": [
      "Piedāvājums dienas laikā",
      "Pielāgots atmaksas grafiks",
      "Dinamiska apkapošana",
      "Individuāla pieeja",
      "Noslēdz attālināti",
      "Minimāla birokrātija"
    ],
    "service_description": "Finlo darbības virziens ir aizdevumu izsniegšana ar nekustamā īpašuma nodrošinājumu jeb hipotekārais kredīts. Izprotot klientu vēlmes un vajadzības, esam izstrādājuši pieteikšanās un kredīta izvērtēšanas procedūru pēc iespējas ērtāku un klientam piemērotāku.",
    "service_image_alt": "Finlo pakalpojumu attēls",
    "service_title": "Personiska pieeja un profesionāla apkalpošana",
    "services_title": "Mūsu pakalpojumu klāsts",
    "slides": {
      "auto_leasing": {
        "description": "Pilna servisa auto līzings ar visām papildu pakalpojumiem - no transportlīdzekļa izvēles līdz apkopes organizēšanai.",
        "title": "Auto līzings"
      },
      "business_development": {
        "description": "Kapitāls jaunu projektu realizēšanai, uzņēmuma izaugsmei un konkurētspējas uzlabošanai.",
        "title": "Biznesa attīstībai"
      },
      "construction": {
        "description": "Finansējums jaunu ēku būvniecībai vai esošo ēku rekonstrukcijai, nodrošinot kvalitatīvu un mūsdienīgu būvniecību.",
        "title": "Ēku būvniecībai"
      },
      "credit_consolidation": {
        "description": "Apvienojiet vairākus kredītus vienā, samazinot ikmēneša maksājumu un vienkāršojot finanšu plānošanu.",
        "title": "Kredītu apvienošana"
      },
      "farmers": {
        "description": "Finansējums lauksaimniecības tehnikas remontam un uzturēšanai, nodrošinot nepārtrauktu saimniecības darbību.",
        "title": "Zemniekiem"
      },
      "mortgage_loan": {
        "description": "Aizdevumi ar nekustamā īpašuma nodrošinājumu jebkādiem mērķiem - mājokļa iegādei, remontam vai citiem vajadzībām.",
        "title": "Hipotekārais kredīts"
      }
    },
    "why_us_title": "Kāpēc izvēlēties mūs?"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    }
  },
  "language_switcher": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский"
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский"
  },
  "loan_form": {
    "buttons": {
      "back_full": "← Atpakaļ",
      "back_short": "← Atpakaļ",
      "close_full": "Aizvērt",
      "limit_exceeded": "Pārsniegts pieteikumu limits",
      "next_full": "Tālāk →",
      "next_short": "Tālāk →",
      "submit_full": "✓ Iesniegt pieteikumu",
      "submit_short": "✓ Iesniegt"
    },
    "family_status": {
      "married": "Precējies",
      "single": "Brīvs"
    },
    "fields": {
      "addresses_match": "Faktiskā adrese sakrīt ar deklarēto",
      "agree_terms": "Es piekrītu <a href='/documents/lv/terms.pdf' target='_blank' rel='noopener noreferrer' class='text-primary-500 hover:text-primary-600 font-medium underline'>lietošanas noteikumiem</a> un <a href='/documents/lv/privacy_policy.pdf' target='_blank' rel='noopener noreferrer' class='text-primary-500 hover:text-primary-600 font-medium underline'>privātuma politikai</a>",
      "bank_account": "Bankas konts",
      "bank_authorization": "Es atļauju piekļūt maniem bankas datiem automatizētai verifikācijai",
      "city": "Pilsēta / Ciems",
      "declared_address": "Iela / mājas nosaukums",
      "dependent_persons": "Apgādībā esošo personu skaits",
      "documents": "Augšupielādējiet nepieciešamos dokumentus",
      "email": "E-pasts",
      "factual_address": "Iela / mājas nosaukums",
      "family_status": "Ģimenes statuss",
      "first_name": "Vārds",
      "has_real_estate": "Vai Tev pieder nekustamais īpašums?",
      "is_politically_important": "Vai Jūs esat politiski nozīmīga persona?",
      "is_politically_important_tooltip": "Politiski nozīmīga persona ir fiziska persona, kas pilda vai ir pildījusi nozīmīgu publisku funkciju, piemēram, valsts vai valdības vadītājs, ministrs, parlamenta deputāts u.c.",
      "job_type": "Darba veids",
      "last_name": "Uzvārds",
      "loan_amount": "Aizdevuma summa",
      "loan_period": "Aizdevuma termiņš",
      "loan_type": "Aizdevuma veids",
      "monthly_income": "Ikmēneša ienākumi, EUR",
      "monthly_payments": "Ikmēneša kredītu maksājumi, EUR",
      "personal_code": "Personas kods",
      "phone": "Telefons",
      "select_bank": "Izvēlieties banku"
    },
    "file_upload": {
      "error": "Kļūda augšupielādējot failu",
      "max": "Maksimālais failu skaits sasniegts",
      "removed": "Fails noņemts",
      "size": "Fails pārāk liels",
      "success": "Fails veiksmīgi augšupielādēts",
      "type": "Nepareizs faila tips"
    },
    "job_types": {
      "other": "Cits",
      "permanent": "Pastāvīgs darbs",
      "retired": "Pensionārs",
      "self_employed": "Pašnodarbināts",
      "student": "Students",
      "temporary": "Pagaidu darbs",
      "unemployed": "Bezdarbnieks"
    },
    "limit_exceeded": "Jūs esat pārsniedzis iespējamo pieteikumu skaitu.",
    "loan_types": {
      "business": "Biznesa kredīts",
      "carLeasing": "Auto līzings",
      "consumer": "Patēriņa kredīts",
      "credit_consolidation": "Kredītu apvienošana",
      "mortgage": "Hipotekārais kredīts"
    },
    "messages": {
      "error": "Radās kļūda. Lūdzu mēģiniet vēlreiz vai sazinieties ar mums.",
      "success": "Pieteikums veiksmīgi iesniegts! Mēs sazināsimies ar jums tuvākajā laikā."
    },
    "no": "Nē",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Rīga",
      "declared_address": "Brīvības iela 123, Rīga",
      "monthly_income": "0",
      "monthly_payments": "0",
      "personal_code": "123456-12345",
      "phone": "22222222",
      "select_bank": "Izvēlieties banku",
      "select_count": "Izvēlieties skaitu",
      "select_job_type": "Izvēlieties darba veidu",
      "select_loan_type": "Izvēlieties aizdevuma veidu",
      "select_status": "Izvēlieties statusu"
    },
    "processing": "Apstrādā...",
    "remaining_applications": "Atlikušie pieteikumi:",
    "step_descriptions": {
      "address_info": "Norādiet savu dzīvesvietas informāciju",
      "bank_verification": "Izvēlieties bankas verifikācijas veidu",
      "family_info": "Informācija par ģimenes statusu un nodarbošanos",
      "loan_details": "Izvēlieties aizdevuma veidu un summu",
      "personal_info": "Lūdzu ievadiet savu personīgo informāciju"
    },
    "step_labels": {
      "address_full": "Adreses informācija",
      "address_short": "Adrese",
      "bank_full": "Bankas verifikācija",
      "bank_short": "Banka",
      "family_full": "Ģimenes informācija",
      "family_short": "Ģimene",
      "loan_full": "Aizdevuma detaļas",
      "loan_short": "Aizdevums",
      "personal_full": "Personīgā informācija",
      "personal_short": "Personīgā"
    },
    "step_titles": {
      "address_info": "Adreses informācija",
      "bank_verification": "Bankas verifikācija",
      "family_info": "Ģimenes informācija",
      "loan_details": "Aizdevuma detaļas",
      "personal_info": "Personīgā informācija"
    },
    "title": "Aizdevuma pieteikums",
    "try_again_in": "Lūdzu mēģiniet vēlreiz pēc",
    "units": {
      "euro": "€",
      "months": "mēneši"
    },
    "yes": "Jā"
  },
  "loan_type_page": {
    "benefits_description": "Mūsu kredīts piedāvā vairākus būtiskus ieguvumus jūsu finansiālajai stabilitātei",
    "benefits_title": "Ieguvumi",
    "contact_description": "Sazinieties ar mūsu ekspertiem un saņemiet personalizētu konsultāciju",
    "contact_title": "Vai jums ir jautājumi?",
    "faq_title": "Biežāk uzdotie jautājumi",
    "how_to_apply_title": "Kā pieteikties?",
    "interest_rate": "Procentu likme gadā:",
    "key_conditions": "Galvenie nosacījumi",
    "period": "Periods:",
    "phone_number": "67199606",
    "security": "Nodrošinājums:",
    "success_message": "Jūsu pieteikums ir nosūtīts! Mēs ar jums sazināsimies tuvākajā laikā."
  },
  "loan_types": {
    "auto": {
      "description": "Ērti un ātri auto iegādei ar mūsu līzinga piedāvājumiem",
      "features": [
        "Procentu likme no 7% + EURIBOR",
        "Auto vērtība līdz 100 000 EUR",
        "Atmaksas termiņš līdz 7 gadiem",
        "Jauni un lietoti auto",
        "Ātra apstiprināšana",
        "Bez pirmā iemaksa"
      ],
      "requirements": [
        "Auto izvēle un cena",
        "Ienākumu apliecinoši dokumenti",
        "Personu identifikācijas dokuments",
        "Auto apdrošināšana"
      ],
      "title": "Auto līzings"
    },
    "business": {
      "description": "Finansējums uzņēmumu izaugsmei un jaunu projektu realizēšanai",
      "features": [
        "Procentu likme no 12% + EURIBOR",
        "Kredīta summa līdz 500 000 EUR",
        "Atmaksas termiņš līdz 25 gadiem",
        "Individuāls risinājums katram uzņēmumam",
        "Elastīgi maksājumu nosacījumi",
        "Personalizēta klientu apkalpošana"
      ],
      "requirements": [
        "Informācija par nekustamo īpašumu",
        "Uzņēmuma bilance",
        "Konta pārskats par pēdējiem 6 mēnešiem vai bankas autorizāija pēdējā pietiekuma solī"
      ],
      "title": "Biznesa attīstībai"
    },
    "consolidation": {
      "description": "Apvienojiet esošos kredītus vienā ar labākiem nosacījumiem",
      "features": [
        "Zemāka kopējā procentu likme",
        "Viens ikmēneša maksājums",
        "Pagarināts atmaksas termiņš",
        "Samazināts ikmēneša maksājums",
        "Vienkāršota administrēšana",
        "Bez slēptām komisijām"
      ],
      "requirements": [
        "Nepieciešamie dokumenti",
        "Bankas verifikācija pieteikuma pēdējā solī"
      ],
      "title": "Kredītu apvienošana"
    },
    "construction": {
      "description": "Specializēts finansējums būvniecības projektiem un renovācijai",
      "features": [
        "Procentu likme no 7% + EURIBOR",
        "Kredīta summa līdz 1 000 000 EUR",
        "Atmaksas termiņš līdz 35 gadiem",
        "Posmu finansēšana",
        "Būvniecības uzraudzība",
        "Profesionāla konsultēšana"
      ],
      "requirements": [
        "Informācija par nekustamo īpašumu",
        "Būvniecības tāme"
      ],
      "title": "Ēku būvniecībai"
    },
    "farm": {
      "description": "Specializēts finansējums lauksaimniecības vajadzībām",
      "features": [
        "Sezonālie maksājumi",
        "Individuāli pielāgoti nosacījumi",
        "Tehnikas un iekārtu finansēšana",
        "Apgrozāmo līdzekļu kredīti",
        "Zemes iegādes finansējums",
        "ES fondu līdzfinansējuma kredīti"
      ],
      "requirements": [
        "Saimniecības reģistrācijas dokumenti",
        "Zemes lietošanas tiesību apliecinājums",
        "Ražošanas plāns",
        "Finanšu dokumenti"
      ],
      "title": "Zemniekiem"
    },
    "features_list": {
      "fast_processing": "Ātra apstrāde",
      "fast_processing_desc": "Lēmums par aizdevumu tiek pieņemts 24 stundu laikā pēc visu dokumentu saņemšanas.",
      "flexible_terms": "Elastīgi nosacījumi",
      "flexible_terms_desc": "Pielāgojam kredīta nosacījumus katram klientam individuāli, ņemot vērā specifiskās vajadzības.",
      "personal_approach": "Personīga pieeja",
      "personal_approach_desc": "Katram klientam piedāvājam individuālu risinājumu, kas atbilst jūsu vajadzībām."
    },
    "features_title": "Mūsu priekšrocības",
    "mortgage": {
      "description": "Aizdevumi ar nekustamā īpašuma nodrošinājumu jebkādiem mērķiem",
      "features": [
        "Procentu likme no 9% + EURIBOR",
        "Kredīta summa līdz 300 000 EUR",
        "Atmaksas termiņš līdz 30 gadiem",
        "Ātra izvērtēšana - 1 darba diena",
        "Elastīgi maksājumu grafiki",
        "Bez papildu komisijām"
      ],
      "requirements": [
        "Nekustamā īpašuma ķīla",
        "Ienākumu apliecinoši dokumenti",
        "Īpašuma vērtēšanas ziņojums",
        "Personu identifikācijas dokuments"
      ],
      "title": "Hipotekārais kredīts"
    },
    "page_description": "Izvēlieties piemērotāko aizdevuma veidu savām vajadzībām. Mēs piedāvājam plašu pakalpojumu klāstu dažādiem mērķiem.",
    "page_title": "Mūsu <span class='text-primary-500'>Pakalpojumi</span>",
    "pages": {
      "auto": {
        "apply_button": "Pieteikt auto līzingu",
        "hero_subtitle": "Ērti un ātri auto iegādei ar mūsu līzinga piedāvājumiem",
        "hero_title": "Auto līzings",
        "meta_description": "Auto līzings jaunu un lietotu auto iegādei. Kredīta summa līdz 100 000 EUR, bez pirmā iemaksa.",
        "meta_title": "Auto līzings - Finlo",
        "title": "Auto līzings"
      },
      "business": {
        "apply_button": "Pieteikt biznesa kredītu",
        "hero_subtitle": "Finansējums uzņēmumu izaugsmei un jaunu projektu realizēšanai",
        "hero_title": "Biznesa attīstībai",
        "meta_description": "Biznesa kredīts uzņēmumu attīstībai. Kredīta summa līdz 500 000 EUR, elastīgi nosacījumi.",
        "meta_title": "Biznesa kredīts - Finlo",
        "title": "Biznesa attīstībai"
      },
      "consolidation": {
        "apply_button": "Pieteikt kredītu apvienošanu",
        "hero_subtitle": "Apvienojiet esošos kredītus vienā ar labākiem nosacījumiem",
        "hero_title": "Kredītu apvienošana",
        "meta_description": "Apvienojiet esošos kredītus vienā ar labākiem nosacījumiem. Samaziniet ikmēneša maksājumu.",
        "meta_title": "Kredītu apvienošana - Finlo",
        "title": "Kredītu apvienošana"
      },
      "construction": {
        "apply_button": "Pieteikt būvniecības kredītu",
        "hero_subtitle": "Specializēts finansējums būvniecības projektiem un renovācijai",
        "hero_title": "Ēku būvniecībai",
        "meta_description": "Būvniecības kredīts jaunu ēku celtniecībai. Kredīta summa līdz 1 000 000 EUR, posmu finansēšana.",
        "meta_title": "Būvniecības kredīts - Finlo",
        "title": "Ēku būvniecībai"
      },
      "farmers": {
        "apply_button": "Pieteikt lauksaimniecības kredītu",
        "hero_subtitle": "Specializēts finansējums lauksaimniecības vajadzībām",
        "hero_title": "Zemniekiem",
        "meta_description": "Specializēts finansējums lauksaimniecības vajadzībām. Sezonālie maksājumi, individuāli nosacījumi.",
        "meta_title": "Lauksaimniecības kredīts - Finlo",
        "title": "Zemniekiem"
      },
      "mortgage": {
        "apply_button": "Pieteikt hipotekāro kredītu",
        "hero_subtitle": "Aizdevumi ar nekustamā īpašuma nodrošinājumu jebkādiem mērķiem",
        "hero_title": "Hipotekārais kredīts",
        "meta_description": "Hipotekārais kredīts ar labākajām procentu likmēm. Kredīta summa līdz 300 000 EUR, atmaksas termiņš līdz 30 gadiem.",
        "meta_title": "Hipotekārais kredīts - Finlo",
        "title": "Hipotekārais kredīts"
      }
    },
    "tab_labels": {
      "business": "Biznesam",
      "consolidation": "Apvienošana",
      "construction": "Būvniecībai",
      "farm": "Zemniekiem",
      "mortgage": "Hipotekārais"
    }
  },
  "loan_types_component": {
    "apply_button": "Pieteikties tagad",
    "form_description": "Aizpildiet pieteikumu un saņemiet piedāvājumu dažu minūšu laikā",
    "form_description_desktop": "Aizpildiet pieteikumu un saņemiet piedāvājumu",
    "form_title": "Pieteikt aizdevumu",
    "image_alt": "Laimīga finanšu sieviete",
    "success_message": "Jūsu pieteikums ir nosūtīts! Mēs ar jums sazināsimies tuvākajā laikā.",
    "title": "Mūsu aizdevumu veidi"
  },
  "meta": {
    "keywords": "aizdevums, kredīts, hipotēka, biznesa kredīts, finlo",
    "og_description": "Finlo darbības virziens ir aizdevumu izsniegšana ar nekustamā īpašuma nodrošinājumu jeb hipotekārais kredīts. Izprotot klientu vēlmes un vajadzības, esam izstrādājuši pieteikšanās un kredīta izvērtēšanas procedūru pēc iespējas ērtāku un klientam piemērotāku.",
    "og_image": "https://www.finlo.lv/og-image.jpg",
    "og_locale": "lv_LV",
    "og_title": "Finlo - Mūsdienīga pieeja aizdevumu izsniegšanai",
    "og_type": "website",
    "og_url": "https://www.finlo.lv",
    "site_description": "Mūsdienīga pieeja aizdevumu izsniegšanai. Licencēts aizdevējs ar NĪ nodrošinātiem kredītiem.",
    "site_name": "Finlo",
    "twitter_card": "summary_large_image",
    "twitter_description": "Licencēts aizdevējs ar NĪ nodrošinātiem kredītiem. Kreditējam visā Latvijā no 2008. gada.",
    "twitter_image": "https://www.finlo.lv/twitter-image.jpg",
    "twitter_site": "@finlo_lv",
    "twitter_title": "Finlo - Mūsdienīga pieeja aizdevumu izsniegšanai"
  },
  "months": {
    "april": "Aprīlis",
    "august": "Augusts",
    "december": "Decembris",
    "february": "Februāris",
    "january": "Janvāris",
    "july": "Jūlijs",
    "june": "Jūnijs",
    "march": "Marts",
    "may": "Maijs",
    "november": "Novembris",
    "october": "Oktobris",
    "september": "Septembris"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "miljards",
            "other": "miljardi",
            "zero": "miljardi"
          },
          "million": {
            "one": "miljons",
            "other": "miljoni",
            "zero": "miljoni"
          },
          "quadrillion": {
            "one": "kvadriljons",
            "other": "kvadriljoni",
            "zero": "kvadriljoni"
          },
          "thousand": {
            "one": "tūkstotis",
            "other": "tūkstoši",
            "zero": "tūkstoši"
          },
          "trillion": {
            "one": "triljons",
            "other": "triljoni",
            "zero": "triljoni"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "baits",
            "other": "baiti",
            "zero": "baiti"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "%{number}.",
      "ordinals": "."
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "periods": {
    "month": "mēnesis",
    "months": "mēneši",
    "year": "gads",
    "years": "gadi"
  },
  "phone": {
    "country_codes": {
      "de": "DE +49",
      "dk": "DK +45",
      "ee": "EE +372",
      "false": "NO +47",
      "fi": "FI +358",
      "gb": "GB +44",
      "lt": "LT +370",
      "lv": "LV +371",
      "se": "SE +46",
      "us": "US +1"
    }
  },
  "services": {
    "auto_leasing": "Auto līzings",
    "business_development": "Biznesa attīstībai",
    "construction": "Ēku būvniecībai",
    "farmers": "Zemniekiem",
    "loan_consolidation": "Kredītu apvienošana",
    "mortgage_loan": "Hipotekārais kredīts"
  },
  "support": {
    "array": {
      "last_word_connector": " un ",
      "two_words_connector": " un ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "priekšpusdiena",
    "formats": {
      "default": "%Y. gada %e. %B, %H:%M",
      "long": "%Y. gada %e. %B, %H:%M:%S",
      "short": "%d.%m.%Y., %H:%M"
    },
    "pm": "pēcpusdiena"
  }
});
I18n.translations["ru"] = I18n.extend((I18n.translations["ru"] || {}), {
  "activerecord": {
    "errors": {
      "messages": {
        "record_invalid": "Pārbaude neizdevās: %{errors}",
        "restrict_dependent_destroy": {
          "has_many": "Nevar dzēst ierakstu, jo ir atkarīgi %{record}",
          "has_one": "Nevar dzēst ierakstu, jo ir atkarīgs %{record}"
        }
      }
    }
  },
  "add_bank_account": {
    "perform_authorization": "Veikt bankas autentifikāciju"
  },
  "app": {
    "navigation": {
      "contact_title": "Finlo - Kontakti",
      "home_title": "Finlo - Sākumlapa",
      "loan_types_title": "Finlo - Aizdevumu veidi"
    },
    "pages": {
      "contact": "Kontakti",
      "home": "Sākums",
      "loan_types": "Aizdevumu veidi",
      "services": "Pakalpojumi"
    }
  },
  "common": {
    "apply": "PIETEIKTIES",
    "back": "Atpakaļ",
    "cancel": "Atcelt",
    "close": "Aizvērt",
    "confirm": "Apstiprināt",
    "contact_us": "Sazinieties ar mums",
    "delete": "Dzēst",
    "edit": "Rediģēt",
    "error": "Kļūda",
    "learn_more": "Uzzināt vairāk",
    "loading": "Notiek ielāde...",
    "next": "Tālāk",
    "required": "*",
    "save": "Saglabāt",
    "submit": "Nosūtīt",
    "success": "Veiksmīgi"
  },
  "contact": {
    "address_full": "Bukultu iela 11, Rīga, LV-1005",
    "address_hours": "Darba dienās: 9:00 - 18:00",
    "address_label": "Adrese",
    "contact_info_title": "Kontaktinformācija",
    "email_address": "info@finlo.lv",
    "email_label": "E-pasts",
    "email_response": "Atbildēsim 24h laikā",
    "error_message": "Atvainojiet, radās kļūda nosūtot ziņojumu. Lūdzu mēģiniet vēlreiz vai zvaniet mums.",
    "form": {
      "agree_marketing": "Es vēlos saņemt informāciju par jaunākajiem piedāvājumiem un aktualitātēm",
      "agree_terms_prefix": "Es piekrītu",
      "and": "un",
      "description": "Aizpildiet formu, un mēs sazināsimies ar jums pēc iespējas ātrāk.",
      "email": "E-pasta adrese",
      "first_name": "Vārds",
      "last_name": "Uzvārds",
      "message": "Ziņojums",
      "phone": "Telefona numurs",
      "privacy_policy_link": "privātuma politikai",
      "subject": "Temats",
      "submit_button": "Nosūtīt ziņojumu",
      "submitting": "Nosūta...",
      "terms_link": "lietošanas noteikumiem",
      "title": "Sūtīt ziņojumu"
    },
    "page_description": "Mums ir svarīgi dzirdēt jūsu viedokli un atbildēt uz jūsu jautājumiem. Sazinieties ar mums, un mēs atbildēsim 24 stundu laikā.",
    "page_title": "Sazinieties ar <span class='text-primary-500'>mums</span>",
    "phone_hours": "Darba dienās: 9:00 - 18:00",
    "phone_label": "Telefons",
    "phone_number": "67199606",
    "subjects": {
      "complaint": "Sūdzība",
      "existing": "Esošā aizdevuma jautājumi",
      "general": "Vispārīgi jautājumi",
      "loan": "Aizdevuma pieteikums",
      "other": "Cits"
    },
    "success_message": "Paldies par jūsu ziņojumu! Mēs sazināsimies ar jums!",
    "validation": {
      "email_invalid": "Nepareizs e-pasta formāts",
      "email_required": "E-pasta adrese ir obligāta",
      "first_name_required": "Vārds ir obligāts",
      "last_name_required": "Uzvārds ir obligāts",
      "message_required": "Ziņojums ir obligāts",
      "phone_required": "Telefona numurs ir obligāts",
      "subject_required": "Temats ir obligāts",
      "terms_required": "Jums jāpiekrīt privātuma politikai un lietošanas noteikumiem"
    }
  },
  "cookie_consent": {
    "accept": "Pieņemt",
    "decline": "Noraidīt",
    "message": "Mēs izmantojam sīkfailus, lai uzlabotu jūsu pieredzi mūsu vietnē. Turpinot izmantot vietni, jūs piekrītat mūsu",
    "privacy_policy_link": "privātuma politikai"
  },
  "currency": {
    "eur": "EUR",
    "symbol": "€"
  },
  "date": {
    "abbr_day_names": [
      "Sv.",
      "P.",
      "O.",
      "T.",
      "C.",
      "Pk.",
      "S."
    ],
    "abbr_month_names": [
      null,
      "Janv",
      "Febr",
      "Marts",
      "Apr",
      "Maijs",
      "Jūn",
      "Jūl",
      "Aug",
      "Sept",
      "Okt",
      "Nov",
      "Dec"
    ],
    "day_names": [
      "svētdiena",
      "pirmdiena",
      "otrdiena",
      "trešdiena",
      "ceturtdiena",
      "piektdiena",
      "sestdiena"
    ],
    "formats": {
      "default": "%d.%m.%Y.",
      "long": "%Y. gada %e. %B",
      "short": "%e. %B"
    },
    "month_names": [
      null,
      "janvārī",
      "februārī",
      "martā",
      "aprīlī",
      "maijā",
      "jūnijā",
      "jūlijā",
      "augustā",
      "septembrī",
      "oktobrī",
      "novembrī",
      "decembrī"
    ],
    "order": [
      "year",
      "month",
      "day"
    ]
  },
  "datetime": {
    "distance_in_words": {
      "about_x_hours": {
        "one": "apmēram %{count} stunda",
        "other": "apmēram %{count} stundas",
        "zero": "apmēram %{count} stundas"
      },
      "about_x_months": {
        "one": "apmēram %{count} mēnesis",
        "other": "apmēram %{count} mēneši",
        "zero": "apmēram %{count} mēneši"
      },
      "about_x_years": {
        "one": "apmēram %{count} gads",
        "other": "apmēram %{count} gadi",
        "zero": "apmēram %{count} gadi"
      },
      "almost_x_years": {
        "one": "gandrīz %{count} gads",
        "other": "gandrīz %{count} gadi",
        "zero": "gandrīz %{count} gadi"
      },
      "half_a_minute": "pusminūte",
      "less_than_x_minutes": {
        "one": "mazāk par %{count} minūti",
        "other": "mazāk par %{count} minūtēm",
        "zero": "mazāk par %{count} minūtēm"
      },
      "less_than_x_seconds": {
        "one": "mazāk par %{count} sekundi",
        "other": "mazāk par %{count} sekundēm",
        "zero": "mazāk par %{count} sekundēm"
      },
      "over_x_years": {
        "one": "vairāk kā %{count} gads",
        "other": "vairāk kā %{count} gadi",
        "zero": "vairāk kā %{count} gadi"
      },
      "x_days": {
        "one": "%{count} diena",
        "other": "%{count} dienas",
        "zero": "%{count} dienas"
      },
      "x_minutes": {
        "one": "%{count} minūte",
        "other": "%{count} minūtes",
        "zero": "%{count} minūtes"
      },
      "x_months": {
        "one": "%{count} mēnesis",
        "other": "%{count} mēneši",
        "zero": "%{count} mēneši"
      },
      "x_seconds": {
        "one": "%{count} sekunde",
        "other": "%{count} sekundes",
        "zero": "%{count} sekundes"
      }
    },
    "prompts": {
      "day": "diena",
      "hour": "stunda",
      "minute": "minūte",
      "month": "mēnesis",
      "second": "sekunde",
      "year": "gads"
    }
  },
  "errors": {
    "format": "%{attribute} %{message}",
    "messages": {
      "accepted": "ir jāpiekrīt",
      "blank": "ir jābūt aizpildītam",
      "confirmation": "nesakrīt ar apstiprinājumu",
      "empty": "ir jābūt aizpildītam",
      "equal_to": "ir jābūt vienādam ar %{count}",
      "even": "ir jābūt pāra skaitlim",
      "exclusion": "nav pieejams",
      "greater_than": "ir jābūt lielākam par %{count}",
      "greater_than_or_equal_to": "ir jābūt lielākam vai vienādam ar %{count}",
      "inclusion": "nav iekļauts sarakstā",
      "invalid": "nav derīgs",
      "less_than": "ir jābūt mazākam par %{count}",
      "less_than_or_equal_to": "ir jābūt mazākam vai vienādam ar %{count}",
      "model_invalid": "Validācija neizdevās: %{errors}",
      "not_a_number": "nav skaitlis",
      "not_an_integer": "ir jābūt veselam skaitlim",
      "odd": "ir jābūt nepāra skaitlim",
      "other_than": "jābūt citam nekā %{count}",
      "present": "jābūt tukšam",
      "required": "ir jābūt",
      "taken": "ir jau aizņemts",
      "too_long": {
        "one": "ir par garu (maksimums ir %{count} simbols)",
        "other": "ir par garu (maksimums ir %{count} simboli)",
        "zero": "ir par garu (maksimums ir %{count} simboli)"
      },
      "too_short": {
        "one": "ir par īsu (minimums ir %{count} simbols)",
        "other": "ir par īsu (minimums ir %{count} simboli)",
        "zero": "ir par īsu (minimums ir %{count} simboli)"
      },
      "wrong_length": {
        "one": "ir nepareizs garums (jābūt %{count} simbolam)",
        "other": "ir nepareizs garums (jābūt %{count} simboliem)",
        "zero": "ir nepareizs garums (jābūt %{count} simboliem)"
      }
    },
    "template": {
      "body": "Problēmas ir šajos ievades laukos:",
      "header": {
        "one": "Dēļ %{count} kļūdas šis %{model} netika saglabāts",
        "other": "Dēļ %{count} kļūdām šis %{model} netika saglabāts",
        "zero": "Dēļ %{count} kļūdām šis %{model} netika saglabāts"
      }
    }
  },
  "footer": {
    "about_us": "Par mums",
    "contacts": "Kontakti",
    "faq": "BUJ",
    "license": "Licence Nr.2016-026",
    "logo_alt": "Finlo",
    "other_title": "Cits",
    "privacy_policy": "Privātuma politika",
    "services": {
      "business_loan": "Biznesa attīstībai",
      "construction_loan": "Ēku būvniecībai",
      "farm_loan": "Zemniekiem",
      "loan_consolidation": "Kredītu apvienošana",
      "mortgage_loan": "Hipotekārais kredīts"
    },
    "services_title": "Pakalpojumi",
    "social_networks": "Sociālie tīkli",
    "terms_of_use": "Lietošanas noteikumi"
  },
  "header": {
    "address": "Bukultu iela 11, Rīga, LV-1005",
    "contact": "Kontakti",
    "contacts": "Kontakti",
    "faq": "BUJ",
    "home": "Sākums",
    "how_to_apply": "Kā pieteikties?",
    "logo_alt": "Finlo",
    "phone": "67199606",
    "services": "Pakalpojumi",
    "why_us": "Kāpēc mēs?",
    "working_hours": "Pirmdiena-Piektdiena: 08-17"
  },
  "helpers": {
    "select": {
      "prompt": "Lūdzu izvēlies"
    },
    "submit": {
      "create": "Izveidot %{model}",
      "submit": "Saglabāt %{model}",
      "update": "Atjaunināt %{model}"
    }
  },
  "home": {
    "about_us_title": "Par mums",
    "contact_page": {
      "company_address": "Bukultu iela 11, Rīga, LV-1005",
      "company_details": "Rekvizīti",
      "company_name": "SIA \"Digital Investment MGMT\"",
      "company_registration": "Reģistrācijas Nr: 40103162565",
      "faq_description": "Atbildes uz biežāk uzdotajiem jautājumiem par mūsu pakalpojumiem",
      "faq_section": "BUJ",
      "how_to_get_there": "Kā nokļūt?",
      "license": "Licence Nr.2016-026",
      "privacy_policy": "Privātuma politika",
      "social_networks": "Sociālie tīkli",
      "terms_of_use": "Lietošanas noteikumi",
      "working_hours": "Darba laiks",
      "working_hours_weekdays": "P-Pk. 8:00-17:00",
      "working_hours_weekend": "S., Sv.- slēgts"
    },
    "contact_phone": "67199606",
    "contact_us_title": "Sazinies ar mums",
    "faq": [
      {
        "title": "Vai iespējams kredītu atdot ātrāk?",
        "content": "Jā, kredītu pirms termiņa iespējams atdot ātrāk."
      },
      {
        "title": "Vai daļu kredīta iespējams saņemt uzreiz?",
        "content": "Steidzamu biznesa jautājumu risināšanai, varam izvērtēt daļu finansējuma izsniegt līguma parakstīšanas dienā."
      },
      {
        "title": "Ja aizdevumu ņemu kredītu apvienošanai, kurš dzēsīs kredītus?",
        "content": "FINLO aizdevumu pārskaitīs uz Jūsu norēķinu bankas kontu, līdz ar to Jūs būsiet atbildīgs par kredītu dzēšanu un maksājuma uzdevumu iesniegšanu dzēšanas apliecināšanai FINLO."
      },
      {
        "title": "Vai īpašumam tiks veikts nekustamā īpašuma novērtējums?",
        "content": "Jā, mēs pasūtam sertificēta vērtētāja īpašuma novērtējumu."
      }
    ],
    "faq_title": "Biežāk uzdotie jautājumi",
    "features": {
      "all_latvia": "Kreditējam visā Latvijā",
      "licensed_lender": "Licencēts aizdevējs",
      "real_estate_secured": "Nekustamā īpašuma nodrošināti kredīti",
      "since_2008": "Tirgū no 2008. gada"
    },
    "form_submitted_message": "Pieteikums nosūtīts!",
    "hero_title": "Mūsdienīga pieeja<br/>Aizdevumu izsniegšanai",
    "loan_types_page": {
      "application_submitted": "Jūsu pieteikums ir nosūtīts! Mēs ar jums sazināsimies tuvākajā laikā.",
      "apply_for_loan": "Pieteikt",
      "apply_now": "Pieteikties tagad",
      "competitive_rates": "Konkurencespējīgas likmes",
      "competitive_rates_description": "Piedāvājam vienas no zemākajām procentu likmēm tirgū no 9% + EURIBOR.",
      "fast_approval": "Ātra apstiprināšana",
      "fast_approval_description": "Pietekumu izvērtējam vienas darba dienas laikā un sniedzam atbildi ātri.",
      "fill_application": "Aizpildiet pieteikumu un saņemiet piedāvājumu",
      "flexible_terms": "Elastīgi nosacījumi",
      "hero_description": "Izvēlieties piemērotāko aizdevuma veidu savām vajadzībām. Mēs piedāvājam plašu pakalpojumu klāstu dažādiem mērķiem.",
      "hero_title": "Mūsu Pakalpojumi",
      "main_advantages": "Galvenās priekšrocības",
      "personal_approach": "Personīga pieeja",
      "personal_approach_description": "Katram klientam piedāvājam individuālu risinājumu, kas atbilst jūsu vajadzībām.",
      "required_documents": "Nepieciešamie dokumenti",
      "trusted_partner": "Mēs esam jūsu uzticamais partneris aizdevumu jomā ar vairāk nekā 10 gadu pieredzi",
      "why_choose_finlo": "Kāpēc izvēlēties Finlo?"
    },
    "qualities": [
      "Piedāvājums dienas laikā",
      "Pielāgots atmaksas grafiks",
      "Dinamiska apkapošana",
      "Individuāla pieeja",
      "Noslēdz attālināti",
      "Minimāla birokrātija"
    ],
    "service_description": "Finlo darbības virziens ir aizdevumu izsniegšana ar nekustamā īpašuma nodrošinājumu jeb hipotekārais kredīts. Izprotot klientu vēlmes un vajadzības, esam izstrādājuši pieteikšanās un kredīta izvērtēšanas procedūru pēc iespējas ērtāku un klientam piemērotāku.",
    "service_image_alt": "Finlo pakalpojumu attēls",
    "service_title": "Personiska pieeja un profesionāla apkalpošana",
    "services_title": "Mūsu pakalpojumu klāsts",
    "slides": {
      "auto_leasing": {
        "description": "Pilna servisa auto līzings ar visām papildu pakalpojumiem - no transportlīdzekļa izvēles līdz apkopes organizēšanai.",
        "title": "Auto līzings"
      },
      "business_development": {
        "description": "Kapitāls jaunu projektu realizēšanai, uzņēmuma izaugsmei un konkurētspējas uzlabošanai.",
        "title": "Biznesa attīstībai"
      },
      "construction": {
        "description": "Finansējums jaunu ēku būvniecībai vai esošo ēku rekonstrukcijai, nodrošinot kvalitatīvu un mūsdienīgu būvniecību.",
        "title": "Ēku būvniecībai"
      },
      "credit_consolidation": {
        "description": "Apvienojiet vairākus kredītus vienā, samazinot ikmēneša maksājumu un vienkāršojot finanšu plānošanu.",
        "title": "Kredītu apvienošana"
      },
      "farmers": {
        "description": "Finansējums lauksaimniecības tehnikas remontam un uzturēšanai, nodrošinot nepārtrauktu saimniecības darbību.",
        "title": "Zemniekiem"
      },
      "mortgage_loan": {
        "description": "Aizdevumi ar nekustamā īpašuma nodrošinājumu jebkādiem mērķiem - mājokļa iegādei, remontam vai citiem vajadzībām.",
        "title": "Hipotekārais kredīts"
      }
    },
    "why_us_title": "Kāpēc izvēlēties mūs?"
  },
  "i18n": {
    "plural": {
      "keys": [
        "one",
        "other"
      ]
    }
  },
  "language_switcher": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский"
  },
  "languages": {
    "en": "English",
    "lv": "Latviešu",
    "ru": "Русский"
  },
  "loan_form": {
    "buttons": {
      "back_full": "← Atpakaļ",
      "back_short": "← Atpakaļ",
      "close_full": "Aizvērt",
      "limit_exceeded": "Pārsniegts pieteikumu limits",
      "next_full": "Tālāk →",
      "next_short": "Tālāk →",
      "submit_full": "✓ Iesniegt pieteikumu",
      "submit_short": "✓ Iesniegt"
    },
    "family_status": {
      "married": "Precējies",
      "single": "Brīvs"
    },
    "fields": {
      "addresses_match": "Faktiskā adrese sakrīt ar deklarēto",
      "agree_terms": "Es piekrītu <a href='/documents/lv/terms.pdf' target='_blank' rel='noopener noreferrer' class='text-primary-500 hover:text-primary-600 font-medium underline'>lietošanas noteikumiem</a> un <a href='/documents/lv/privacy_policy.pdf' target='_blank' rel='noopener noreferrer' class='text-primary-500 hover:text-primary-600 font-medium underline'>privātuma politikai</a>",
      "bank_account": "Bankas konts",
      "bank_authorization": "Es atļauju piekļūt maniem bankas datiem automatizētai verifikācijai",
      "city": "Pilsēta / Ciems",
      "declared_address": "Iela / mājas nosaukums",
      "dependent_persons": "Apgādībā esošo personu skaits",
      "documents": "Augšupielādējiet nepieciešamos dokumentus",
      "email": "E-pasts",
      "factual_address": "Iela / mājas nosaukums",
      "family_status": "Ģimenes statuss",
      "first_name": "Vārds",
      "has_real_estate": "Vai Tev pieder nekustamais īpašums?",
      "is_politically_important": "Vai Jūs esat politiski nozīmīga persona?",
      "is_politically_important_tooltip": "Politiski nozīmīga persona ir fiziska persona, kas pilda vai ir pildījusi nozīmīgu publisku funkciju, piemēram, valsts vai valdības vadītājs, ministrs, parlamenta deputāts u.c.",
      "job_type": "Darba veids",
      "last_name": "Uzvārds",
      "loan_amount": "Aizdevuma summa",
      "loan_period": "Aizdevuma termiņš",
      "loan_type": "Aizdevuma veids",
      "monthly_income": "Ikmēneša ienākumi, EUR",
      "monthly_payments": "Ikmēneša kredītu maksājumi, EUR",
      "personal_code": "Personas kods",
      "phone": "Telefons",
      "select_bank": "Izvēlieties banku"
    },
    "file_upload": {
      "error": "Kļūda augšupielādējot failu",
      "max": "Maksimālais failu skaits sasniegts",
      "removed": "Fails noņemts",
      "size": "Fails pārāk liels",
      "success": "Fails veiksmīgi augšupielādēts",
      "type": "Nepareizs faila tips"
    },
    "job_types": {
      "other": "Cits",
      "permanent": "Pastāvīgs darbs",
      "retired": "Pensionārs",
      "self_employed": "Pašnodarbināts",
      "student": "Students",
      "temporary": "Pagaidu darbs",
      "unemployed": "Bezdarbnieks"
    },
    "limit_exceeded": "Jūs esat pārsniedzis iespējamo pieteikumu skaitu.",
    "loan_types": {
      "business": "Biznesa kredīts",
      "carLeasing": "Auto līzings",
      "consumer": "Patēriņa kredīts",
      "credit_consolidation": "Kredītu apvienošana",
      "mortgage": "Hipotekārais kredīts"
    },
    "messages": {
      "error": "Radās kļūda. Lūdzu mēģiniet vēlreiz vai sazinieties ar mums.",
      "success": "Pieteikums veiksmīgi iesniegts! Mēs sazināsimies ar jums tuvākajā laikā."
    },
    "no": "Nē",
    "placeholders": {
      "bank_account": "LV80BANK0000435195001",
      "city": "Rīga",
      "declared_address": "Brīvības iela 123, Rīga",
      "monthly_income": "0",
      "monthly_payments": "0",
      "personal_code": "123456-12345",
      "phone": "22222222",
      "select_bank": "Izvēlieties banku",
      "select_count": "Izvēlieties skaitu",
      "select_job_type": "Izvēlieties darba veidu",
      "select_loan_type": "Izvēlieties aizdevuma veidu",
      "select_status": "Izvēlieties statusu"
    },
    "processing": "Apstrādā...",
    "remaining_applications": "Atlikušie pieteikumi:",
    "step_descriptions": {
      "address_info": "Norādiet savu dzīvesvietas informāciju",
      "bank_verification": "Izvēlieties bankas verifikācijas veidu",
      "family_info": "Informācija par ģimenes statusu un nodarbošanos",
      "loan_details": "Izvēlieties aizdevuma veidu un summu",
      "personal_info": "Lūdzu ievadiet savu personīgo informāciju"
    },
    "step_labels": {
      "address_full": "Adreses informācija",
      "address_short": "Adrese",
      "bank_full": "Bankas verifikācija",
      "bank_short": "Banka",
      "family_full": "Ģimenes informācija",
      "family_short": "Ģimene",
      "loan_full": "Aizdevuma detaļas",
      "loan_short": "Aizdevums",
      "personal_full": "Personīgā informācija",
      "personal_short": "Personīgā"
    },
    "step_titles": {
      "address_info": "Adreses informācija",
      "bank_verification": "Bankas verifikācija",
      "family_info": "Ģimenes informācija",
      "loan_details": "Aizdevuma detaļas",
      "personal_info": "Personīgā informācija"
    },
    "title": "Aizdevuma pieteikums",
    "try_again_in": "Lūdzu mēģiniet vēlreiz pēc",
    "units": {
      "euro": "€",
      "months": "mēneši"
    },
    "yes": "Jā"
  },
  "loan_type_page": {
    "benefits_description": "Mūsu kredīts piedāvā vairākus būtiskus ieguvumus jūsu finansiālajai stabilitātei",
    "benefits_title": "Ieguvumi",
    "contact_description": "Sazinieties ar mūsu ekspertiem un saņemiet personalizētu konsultāciju",
    "contact_title": "Vai jums ir jautājumi?",
    "faq_title": "Biežāk uzdotie jautājumi",
    "how_to_apply_title": "Kā pieteikties?",
    "interest_rate": "Procentu likme gadā:",
    "key_conditions": "Galvenie nosacījumi",
    "period": "Periods:",
    "phone_number": "67199606",
    "security": "Nodrošinājums:",
    "success_message": "Jūsu pieteikums ir nosūtīts! Mēs ar jums sazināsimies tuvākajā laikā."
  },
  "loan_types": {
    "auto": {
      "description": "Ērti un ātri auto iegādei ar mūsu līzinga piedāvājumiem",
      "features": [
        "Procentu likme no 7% + EURIBOR",
        "Auto vērtība līdz 100 000 EUR",
        "Atmaksas termiņš līdz 7 gadiem",
        "Jauni un lietoti auto",
        "Ātra apstiprināšana",
        "Bez pirmā iemaksa"
      ],
      "requirements": [
        "Auto izvēle un cena",
        "Ienākumu apliecinoši dokumenti",
        "Personu identifikācijas dokuments",
        "Auto apdrošināšana"
      ],
      "title": "Auto līzings"
    },
    "business": {
      "description": "Finansējums uzņēmumu izaugsmei un jaunu projektu realizēšanai",
      "features": [
        "Procentu likme no 12% + EURIBOR",
        "Kredīta summa līdz 500 000 EUR",
        "Atmaksas termiņš līdz 25 gadiem",
        "Individuāls risinājums katram uzņēmumam",
        "Elastīgi maksājumu nosacījumi",
        "Personalizēta klientu apkalpošana"
      ],
      "requirements": [
        "Informācija par nekustamo īpašumu",
        "Uzņēmuma bilance",
        "Konta pārskats par pēdējiem 6 mēnešiem vai bankas autorizāija pēdējā pietiekuma solī"
      ],
      "title": "Biznesa attīstībai"
    },
    "consolidation": {
      "description": "Apvienojiet esošos kredītus vienā ar labākiem nosacījumiem",
      "features": [
        "Zemāka kopējā procentu likme",
        "Viens ikmēneša maksājums",
        "Pagarināts atmaksas termiņš",
        "Samazināts ikmēneša maksājums",
        "Vienkāršota administrēšana",
        "Bez slēptām komisijām"
      ],
      "requirements": [
        "Nepieciešamie dokumenti",
        "Bankas verifikācija pieteikuma pēdējā solī"
      ],
      "title": "Kredītu apvienošana"
    },
    "construction": {
      "description": "Specializēts finansējums būvniecības projektiem un renovācijai",
      "features": [
        "Procentu likme no 7% + EURIBOR",
        "Kredīta summa līdz 1 000 000 EUR",
        "Atmaksas termiņš līdz 35 gadiem",
        "Posmu finansēšana",
        "Būvniecības uzraudzība",
        "Profesionāla konsultēšana"
      ],
      "requirements": [
        "Informācija par nekustamo īpašumu",
        "Būvniecības tāme"
      ],
      "title": "Ēku būvniecībai"
    },
    "farm": {
      "description": "Specializēts finansējums lauksaimniecības vajadzībām",
      "features": [
        "Sezonālie maksājumi",
        "Individuāli pielāgoti nosacījumi",
        "Tehnikas un iekārtu finansēšana",
        "Apgrozāmo līdzekļu kredīti",
        "Zemes iegādes finansējums",
        "ES fondu līdzfinansējuma kredīti"
      ],
      "requirements": [
        "Saimniecības reģistrācijas dokumenti",
        "Zemes lietošanas tiesību apliecinājums",
        "Ražošanas plāns",
        "Finanšu dokumenti"
      ],
      "title": "Zemniekiem"
    },
    "features_list": {
      "fast_processing": "Ātra apstrāde",
      "fast_processing_desc": "Lēmums par aizdevumu tiek pieņemts 24 stundu laikā pēc visu dokumentu saņemšanas.",
      "flexible_terms": "Elastīgi nosacījumi",
      "flexible_terms_desc": "Pielāgojam kredīta nosacījumus katram klientam individuāli, ņemot vērā specifiskās vajadzības.",
      "personal_approach": "Personīga pieeja",
      "personal_approach_desc": "Katram klientam piedāvājam individuālu risinājumu, kas atbilst jūsu vajadzībām."
    },
    "features_title": "Mūsu priekšrocības",
    "mortgage": {
      "description": "Aizdevumi ar nekustamā īpašuma nodrošinājumu jebkādiem mērķiem",
      "features": [
        "Procentu likme no 9% + EURIBOR",
        "Kredīta summa līdz 300 000 EUR",
        "Atmaksas termiņš līdz 30 gadiem",
        "Ātra izvērtēšana - 1 darba diena",
        "Elastīgi maksājumu grafiki",
        "Bez papildu komisijām"
      ],
      "requirements": [
        "Nekustamā īpašuma ķīla",
        "Ienākumu apliecinoši dokumenti",
        "Īpašuma vērtēšanas ziņojums",
        "Personu identifikācijas dokuments"
      ],
      "title": "Hipotekārais kredīts"
    },
    "page_description": "Izvēlieties piemērotāko aizdevuma veidu savām vajadzībām. Mēs piedāvājam plašu pakalpojumu klāstu dažādiem mērķiem.",
    "page_title": "Mūsu <span class='text-primary-500'>Pakalpojumi</span>",
    "pages": {
      "auto": {
        "apply_button": "Pieteikt auto līzingu",
        "hero_subtitle": "Ērti un ātri auto iegādei ar mūsu līzinga piedāvājumiem",
        "hero_title": "Auto līzings",
        "meta_description": "Auto līzings jaunu un lietotu auto iegādei. Kredīta summa līdz 100 000 EUR, bez pirmā iemaksa.",
        "meta_title": "Auto līzings - Finlo",
        "title": "Auto līzings"
      },
      "business": {
        "apply_button": "Pieteikt biznesa kredītu",
        "hero_subtitle": "Finansējums uzņēmumu izaugsmei un jaunu projektu realizēšanai",
        "hero_title": "Biznesa attīstībai",
        "meta_description": "Biznesa kredīts uzņēmumu attīstībai. Kredīta summa līdz 500 000 EUR, elastīgi nosacījumi.",
        "meta_title": "Biznesa kredīts - Finlo",
        "title": "Biznesa attīstībai"
      },
      "consolidation": {
        "apply_button": "Pieteikt kredītu apvienošanu",
        "hero_subtitle": "Apvienojiet esošos kredītus vienā ar labākiem nosacījumiem",
        "hero_title": "Kredītu apvienošana",
        "meta_description": "Apvienojiet esošos kredītus vienā ar labākiem nosacījumiem. Samaziniet ikmēneša maksājumu.",
        "meta_title": "Kredītu apvienošana - Finlo",
        "title": "Kredītu apvienošana"
      },
      "construction": {
        "apply_button": "Pieteikt būvniecības kredītu",
        "hero_subtitle": "Specializēts finansējums būvniecības projektiem un renovācijai",
        "hero_title": "Ēku būvniecībai",
        "meta_description": "Būvniecības kredīts jaunu ēku celtniecībai. Kredīta summa līdz 1 000 000 EUR, posmu finansēšana.",
        "meta_title": "Būvniecības kredīts - Finlo",
        "title": "Ēku būvniecībai"
      },
      "farmers": {
        "apply_button": "Pieteikt lauksaimniecības kredītu",
        "hero_subtitle": "Specializēts finansējums lauksaimniecības vajadzībām",
        "hero_title": "Zemniekiem",
        "meta_description": "Specializēts finansējums lauksaimniecības vajadzībām. Sezonālie maksājumi, individuāli nosacījumi.",
        "meta_title": "Lauksaimniecības kredīts - Finlo",
        "title": "Zemniekiem"
      },
      "mortgage": {
        "apply_button": "Pieteikt hipotekāro kredītu",
        "hero_subtitle": "Aizdevumi ar nekustamā īpašuma nodrošinājumu jebkādiem mērķiem",
        "hero_title": "Hipotekārais kredīts",
        "meta_description": "Hipotekārais kredīts ar labākajām procentu likmēm. Kredīta summa līdz 300 000 EUR, atmaksas termiņš līdz 30 gadiem.",
        "meta_title": "Hipotekārais kredīts - Finlo",
        "title": "Hipotekārais kredīts"
      }
    },
    "tab_labels": {
      "business": "Biznesam",
      "consolidation": "Apvienošana",
      "construction": "Būvniecībai",
      "farm": "Zemniekiem",
      "mortgage": "Hipotekārais"
    }
  },
  "loan_types_component": {
    "apply_button": "Pieteikties tagad",
    "form_description": "Aizpildiet pieteikumu un saņemiet piedāvājumu dažu minūšu laikā",
    "form_description_desktop": "Aizpildiet pieteikumu un saņemiet piedāvājumu",
    "form_title": "Pieteikt aizdevumu",
    "image_alt": "Laimīga finanšu sieviete",
    "success_message": "Jūsu pieteikums ir nosūtīts! Mēs ar jums sazināsimies tuvākajā laikā.",
    "title": "Mūsu aizdevumu veidi"
  },
  "meta": {
    "keywords": "aizdevums, kredīts, hipotēka, biznesa kredīts, finlo",
    "og_description": "Finlo darbības virziens ir aizdevumu izsniegšana ar nekustamā īpašuma nodrošinājumu jeb hipotekārais kredīts. Izprotot klientu vēlmes un vajadzības, esam izstrādājuši pieteikšanās un kredīta izvērtēšanas procedūru pēc iespējas ērtāku un klientam piemērotāku.",
    "og_image": "https://www.finlo.lv/og-image.jpg",
    "og_locale": "lv_LV",
    "og_title": "Finlo - Mūsdienīga pieeja aizdevumu izsniegšanai",
    "og_type": "website",
    "og_url": "https://www.finlo.lv",
    "site_description": "Mūsdienīga pieeja aizdevumu izsniegšanai. Licencēts aizdevējs ar NĪ nodrošinātiem kredītiem.",
    "site_name": "Finlo",
    "twitter_card": "summary_large_image",
    "twitter_description": "Licencēts aizdevējs ar NĪ nodrošinātiem kredītiem. Kreditējam visā Latvijā no 2008. gada.",
    "twitter_image": "https://www.finlo.lv/twitter-image.jpg",
    "twitter_site": "@finlo_lv",
    "twitter_title": "Finlo - Mūsdienīga pieeja aizdevumu izsniegšanai"
  },
  "months": {
    "april": "Aprīlis",
    "august": "Augusts",
    "december": "Decembris",
    "february": "Februāris",
    "january": "Janvāris",
    "july": "Jūlijs",
    "june": "Jūnijs",
    "march": "Marts",
    "may": "Maijs",
    "november": "Novembris",
    "october": "Oktobris",
    "september": "Septembris"
  },
  "number": {
    "currency": {
      "format": {
        "delimiter": ".",
        "format": "%n %u",
        "precision": 2,
        "separator": ",",
        "significant": false,
        "strip_insignificant_zeros": false,
        "unit": "€"
      }
    },
    "format": {
      "delimiter": ".",
      "precision": 2,
      "separator": ",",
      "significant": false,
      "strip_insignificant_zeros": false
    },
    "human": {
      "decimal_units": {
        "format": "%n %u",
        "units": {
          "billion": {
            "one": "miljards",
            "other": "miljardi",
            "zero": "miljardi"
          },
          "million": {
            "one": "miljons",
            "other": "miljoni",
            "zero": "miljoni"
          },
          "quadrillion": {
            "one": "kvadriljons",
            "other": "kvadriljoni",
            "zero": "kvadriljoni"
          },
          "thousand": {
            "one": "tūkstotis",
            "other": "tūkstoši",
            "zero": "tūkstoši"
          },
          "trillion": {
            "one": "triljons",
            "other": "triljoni",
            "zero": "triljoni"
          },
          "unit": ""
        }
      },
      "format": {
        "delimiter": "",
        "precision": 1,
        "significant": false,
        "strip_insignificant_zeros": false
      },
      "storage_units": {
        "format": "%n %u",
        "units": {
          "byte": {
            "one": "baits",
            "other": "baiti",
            "zero": "baiti"
          },
          "eb": "EB",
          "gb": "GB",
          "kb": "KB",
          "mb": "MB",
          "pb": "PB",
          "tb": "TB"
        }
      }
    },
    "nth": {
      "ordinalized": "%{number}.",
      "ordinals": "."
    },
    "percentage": {
      "format": {
        "delimiter": "",
        "format": "%n%"
      }
    },
    "precision": {
      "format": {
        "delimiter": ""
      }
    }
  },
  "periods": {
    "month": "mēnesis",
    "months": "mēneši",
    "year": "gads",
    "years": "gadi"
  },
  "phone": {
    "country_codes": {
      "de": "DE +49",
      "dk": "DK +45",
      "ee": "EE +372",
      "false": "NO +47",
      "fi": "FI +358",
      "gb": "GB +44",
      "lt": "LT +370",
      "lv": "LV +371",
      "se": "SE +46",
      "us": "US +1"
    }
  },
  "services": {
    "auto_leasing": "Auto līzings",
    "business_development": "Biznesa attīstībai",
    "construction": "Ēku būvniecībai",
    "farmers": "Zemniekiem",
    "loan_consolidation": "Kredītu apvienošana",
    "mortgage_loan": "Hipotekārais kredīts"
  },
  "support": {
    "array": {
      "last_word_connector": " un ",
      "two_words_connector": " un ",
      "words_connector": ", "
    }
  },
  "time": {
    "am": "priekšpusdiena",
    "formats": {
      "default": "%Y. gada %e. %B, %H:%M",
      "long": "%Y. gada %e. %B, %H:%M:%S",
      "short": "%d.%m.%Y., %H:%M"
    },
    "pm": "pēcpusdiena"
  }
});
